import React, { useMemo } from 'react';
import { render } from 'react-dom';
import localforage from 'localforage';
import registerServiceWorker from './registerServiceWorker';

import { configureContainer } from 'op/container';
import Root from './containers/root.container';
import Decrypt from './containers/decrypt';
import './assets/css/globals.css';

const RootWithContainer = ({ storage }) => {
  const container = useMemo(() => configureContainer(storage), [storage]);

  return <Root container={container} />
}

render(	  
  <Decrypt>
    { ({ storage }) => <RootWithContainer storage={storage} /> }
  </Decrypt>,
  document.getElementById("root")
);

if(process.env.NODE_ENV === 'production'){
	registerServiceWorker();
}
